var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.attribute.frontent_input != 'boolean')?_c('SfProperty',{staticClass:"a-product-attribute",attrs:{"name":_vm._f("htmlDecode")(_vm.label),"value":_vm.attributeValue}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }